import { render, staticRenderFns } from "./AffiliatePortalView.vue?vue&type=template&id=52c4585d"
import script from "./AffiliatePortalView.vue?vue&type=script&lang=js"
export * from "./AffiliatePortalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports